import React, { useMemo } from "react"
import { CONTENT_TYPES } from "@/constants"
import { getLinkData } from "@/components/common/Links/utils"
import Item from "@/components/Menu/Shared/Item"
import { getPropSafely } from "@/utils/utils"

const Child = ({ data, square = true, color = "" }) => {
	const { text, url, isInfoItem, isExternal, newCard, ariaLabel, openNewsletter } = useMemo(() => {
		const isMenuRecord = data?.__typename === CONTENT_TYPES.MENU
		const isInfoItem = data?.parent?.isInfoCategory
		const { text, url, isExternal, newCard, ariaLabel } = getLinkData(isMenuRecord ? data?.universalLink : data)
		const openNewsletter = getPropSafely(data, "openNewsletter", false)

		// logTable({
		// 	text,
		// 	url
		// })
		return {
			text,
			url,
			isInfoItem,
			isExternal,
			newCard,
			ariaLabel,
			openNewsletter,
		}
	}, [data])

	return (
		<Item
			newCard={newCard}
			external={isExternal}
			isInfoItem={isInfoItem}
			aria-label={ariaLabel}
			url={url}
			color={color}
			square={square}
			openNewsletter={openNewsletter}
		>
			{text}
		</Item>
	)
}

export default Child
